module.exports = __webpack_public_path__ + "b6615a1f5fd2a2bfb8b66cab39006288.svg";